
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/in-your-community/[post]",
      function () {
        return require("private-next-pages/in-your-community/[post].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/in-your-community/[post]"])
      });
    }
  